import gql from 'graphql-tag'

import { queryServiceCreator } from '../../../../helpers/GraphqlHelpers'
import { PreferencesFragment } from '../../../fragments/PreferencesFragment'
import { ObjectivesFragment } from '../../../fragments/ObjectivesFragment'

const query = gql`
  query me {
    me {
      id
      token
      should_receive_notifications
      notification_frequency
      favorite_recipes {
        id
      }
      push_preferences {
        installIOS
        installAndroid
        notification
      }
      preferences {
        ...PreferencesFragment
      }
      objectives {
        ...ObjectivesFragment
      }
      has_download_menu
    }
  }
  ${PreferencesFragment}
  ${ObjectivesFragment}
`

const transformer = ({ me }: any): any => me

type variables = any

export default queryServiceCreator<variables>(query, transformer)
